<template>
  <div>
    <v-row v-for="(part, partIndex) in offer.parts" :key="part">
      <v-col class="pa-1" md="3" cols="12">
        <v-text-field :label="$t('travelService.hotelName')" filled readonly v-model="part.name"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="3" cols="12">
        <v-rating class="small-rating" readonly v-model="part.hotel_class"></v-rating>
      </v-col>
      <v-col class="pa-1" md="6" cols="12">
        <v-text-field :label="$t('travelService.address')" filled readonly v-model="part.address"></v-text-field>
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.accommodationDate')" filled readonly v-model="part.start_date"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.outDate')" filled readonly v-model="part.end_date"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.numberOfPeoplePerRoom')" filled readonly v-model="part.person_per_room"></v-text-field>
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.roomCount')" filled readonly v-model="part.rooms"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :label="$t('travelService.roomType')" filled readonly v-model="part.room_type"></v-text-field>
      </v-col>
      <v-col class="pa-1" md="4" v-if="part.additional_services != null && part.additional_services.toString().length > 0" cols="12">
        <v-text-field :label="$t('travelService.additionalServices')" filled readonly v-model="part.additional_services"></v-text-field>
      </v-col>

      <v-col class="pa-1" md="4" v-if="part.price_per_day != null && part.price_per_day.toString().length > 0" cols="12">
        <v-text-field :label="$t('travelService.averagePricePerDay')" filled readonly v-model="part.price_per_day"></v-text-field>
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field
          :label="$t('travelService.freeCancelUntil')"
          :placeholder="$t('travelService.noFreeCancel')"
          filled
          readonly
          v-model="part.cancel_until"
        ></v-text-field>
      </v-col>

      <v-col class="pa-1" v-if="part.comment != null && part.comment.length > 0" cols="12">
        <v-textarea :label="$t('travelService.travelAgentComment')" filled readonly v-model="part.comment"></v-textarea>
      </v-col>
      <v-col v-if="partIndex < offer.parts.length - 1" cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "HotelResponsePresentation",
  props: {
    offer: {
      required: true
    }
  }
};
</script>

<style scoped></style>
